import { render, staticRenderFns } from "./CommodityPortfolioScenarios.vue?vue&type=template&id=b88dd4aa&"
import script from "./CommodityPortfolioScenarios.vue?vue&type=script&lang=js&"
export * from "./CommodityPortfolioScenarios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports